import script from "./FullSiblingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullSiblingComponent.vue?vue&type=script&setup=true&lang=ts"

import "./FullSiblingComponent.vue?vue&type=style&index=0&id=15b3669e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b3669e"]])

export default __exports__